import React, { Component } from "react";
import axios from "axios";
import MUITable from "../MUITable/MUITable";
import moment from "moment";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";

class TransactionHistory extends Component {

  constructor(props) {
    super(props);

    const url_array = document.location.href.split("/"); //get the url
    const lcf_id = url_array[url_array.length - 1]; //gets the id from the url

    this.state = {
      history: null,
      subject_lcf_id: lcf_id
    };
  }

  componentDidMount() {
    axios.get(`/api/student/transaction-history/${this.state.subject_lcf_id}`)
      .then(data => this.setState({history: data.data}));
  }

  render() {
    const currencyCellOptions = {
      filter: true, sort: false,
      setCellProps: value => ({
        style: { textAlign: 'right' }
      }),
      setCellHeaderProps: value => ({
        style: { textAlign: 'right' }
      }) 
    };
    const columns = [
      { name: "When",
        options: {
          filter: true, sort: false,
          setCellProps: value => ({
            style: { paddingLeft: '18px' }
          }),
          setCellHeaderProps: value => ({
            style: { paddingLeft: '18px' }
          })
        }
      },
      { name: "Transaction Type", options: { filter: true, sort: false } },
      { name: "Pay Day", options: { filter: false, sort: false } },
      { name: "Comment", options: { filter: true, sort: false } },
      { name: "Regular", options: currencyCellOptions },
      { name: "GPA Bonus", options: currencyCellOptions },
      { name: "Total", options: currencyCellOptions },
      { name: "Amount", options: currencyCellOptions },
      { name: "PIF Donations", options: currencyCellOptions },
      { name: "Chgd Stndt", options: currencyCellOptions },
      { name: "Bal CryOvr", options: currencyCellOptions },
      { name: "$ to student", options: currencyCellOptions },
      { name: "Running Balance",
        options: {
          sort: false, filter: false,
          setCellProps: value => ({
            style: { textAlign: 'right', paddingRight: '18px' }
          }),
          setCellHeaderProps: value => ({
            style: { textAlign: 'right', paddingRight: '18px' }
          }) 
        },
      }
    ];

    return (
      <div>
        <div className="navbuttonscontainer">
          <Link to={`/manual-transaction/${this.state.subject_lcf_id}`}>
            <Button variant="success" style={{margin:'10x'}}>Add Manual Transaction</Button>
          </Link>
        </div>
        {this.state.history ? (
          <div className="dense-table">
            <MUITable
              data={this.jsonToArray(this.calcRunningBalance(this.state.history.reverse()))}
              columns={columns}
              title={"Transaction History"} />
          </div>
        ) : (
          <div>No Data.</div>
        )}
      </div>);
  }
  
  jsonToArray(history) {
    return history.map(
      (entry) => [
        moment(entry.moment).local().format("M/D/YY h:mm"),
        entry.trx_type,
        entry.pay_day_date ?
          moment(entry.pay_day_date).local().format("M/D/YY h:mm") : "N/A",
        entry.comment,
        this.prependCurrency(entry.daily_earned),
        this.prependCurrency(entry.bonus_earned),
        this.prependCurrency(entry.gross_earned),
        this.prependCurrency(entry.amount),
        this.prependCurrency(entry.pif_paid),
        this.prependCurrency(entry.debt_paid),
        this.prependCurrency(entry.debt_remaining),
        this.prependCurrency(entry.paid_to_student),
        "$" + entry.running.toFixed(2)
      ]
    );
  }

  calcRunningBalance(history) {
    if (history.length === 0) {
      return history;
    }
    history[history.length-1].running = parseFloat(history[history.length-1].amount);
    for (let i = history.length-2; i >= 0; i--) {
      history[i].running = history[i+1].running + parseFloat(history[i].amount);
    }
    return history;
  }

  prependCurrency(amount) {
    if (!amount) {
      return "N/A";
    }
    return amount.startsWith('-') ? '-$' + amount.substring(1) : '$' + amount;
  }

}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(TransactionHistory));
